<template>
  <div class="h-120 mt-32 mb-32 hidden md:flex items-center justify-center" data-aos="fade-up" data-aos-duration="1000" data-aos-id="orsus-chain">
    <div class="relative">

      <div ref="top" class="z-20 absolute pin">
        <div class="relative cursor-pointer">
          <div class="px-4 bg-white orsus-chain-circle__small m-auto border-5 z-10 relative border-warm-blue rounded-full flex items-center justify-center z-30">
            <span class="text-charcoal-grey text-lg font-bold">Talent<br>Shows</span> 
          </div>
          <span class="absolute block z-0 h-16 pin-b pin-x mx-auto translate-y-full bg-perrywinkle -mb-1 w-2px" v-show="shown"></span>
          <orsus-chain-details :animated="show" :x-axis="-65" :y-axis="-145" :delay="100">Leading<br>Creators</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="60" :y-axis="-145" :delay="100">Upcoming<br>Talents</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="150" :y-axis="-50" :delay="100">Brand<br>Sponsors</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="-150" :y-axis="-50" :delay="100">Fans</orsus-chain-details>
        </div>
      </div>
      
      <div ref="left" class="z-20 absolute pin" >
        <div class="relative">
          <div class="px-4 bg-white orsus-chain-circle__small m-auto border-5 z-10 relative border-warm-blue rounded-full flex items-center justify-center z-30">
            <span class="text-charcoal-grey text-lg font-bold">Orxchange</span>
            <span class="absolute block z-0 h-2px pin-r pin-y my-auto transform-origin-l bg-perrywinkle -mr-1 w-16" style="transform: rotate(25deg) translateX(100%) translateY(10px)" v-show="shown"></span>
          </div>
          <orsus-chain-details :animated="show" :x-axis="-55" :y-axis="-145" :delay="200">Fans</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="-145" :y-axis="-60" :delay="200"><img src="/assets/images/icons/orsus-icon-white.svg" class="h-12 -mb-2" alt=""></orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="-145" :y-axis="60" :delay="200"><img src="/assets/images/icons/ethereum.svg" class="h-12 -mb-2" alt=""></orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="-55" :y-axis="145" :delay="200"><img src="/assets/images/icons/bitcoin.svg" class="h-12 -mb-2" alt=""></orsus-chain-details>
        </div>
      </div>
      
      <div ref="right" class="z-20 absolute pin">
        <div class="relative">
          <div class="px-4 bg-white orsus-chain-circle__small m-auto border-5 z-10 relative border-warm-blue rounded-full flex items-center justify-center z-30">
            <span class="text-charcoal-grey text-lg font-bold">Personally Owned Platforms</span>
            <span class="absolute block z-0 h-2px pin-l transform-origin-r bg-perrywinkle -ml-1 w-16" style="transform: rotate(-25deg) translateX(-100%) translateY(10px)" v-show="shown"></span>
          </div>
          <orsus-chain-details :animated="show" :x-axis="140" :y-axis="-60">Leading<br>Creators</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="145" :y-axis="60">Fans</orsus-chain-details>
        </div>
      </div>
      
      <div ref="bottomLeft" class="z-20 absolute pin">
        <div class="relative">
          <div class="px-4 bg-white orsus-chain-circle__small m-auto border-5 z-10 relative border-warm-blue rounded-full flex items-center justify-center z-30">
            <span class="text-charcoal-grey text-lg font-bold">Content Discovery/IP Revenue</span>
            <span class="absolute block z-0 h-2px pin-r transform-origin-l bg-perrywinkle w-16" style="transform: rotate(-50deg) translateX(115%) translateY(-1rem)" v-show="shown"></span>
          </div>
          <orsus-chain-details :animated="show" :x-axis="-150" :y-axis="15" :delay="300">Creators</orsus-chain-details>
          <orsus-chain-details :animated="show" :x-axis="-85" :y-axis="125" :delay="300">Fans</orsus-chain-details>
        </div>
      </div>
      
      <div ref="bottomRight" class="z-20 absolute pin">
        <div class="relative cursor-pointer">
          <div class="px-4 bg-white orsus-chain-circle__small m-auto border-5 z-10 relative border-warm-blue rounded-full flex items-center justify-center z-30">
            <span class="text-charcoal-grey text-lg font-bold">3rd Party DApps</span>
            <span class="absolute block z-0 h-2px pin-l transform-origin-r bg-perrywinkle w-16" style="transform: rotate(50deg) translateX(-115%) translateY(-1rem)" v-show="shown"></span>
          </div>
        </div>
      </div>
      
      <div
        class="bg-white orsus-chain-circle__lg relative z-40 border-9 border-perrywinkle-two rounded-full flex flex-col items-center justify-center"
      >
        <img src="/assets/images/icons/orsus-icon.svg" class="mb-3" alt="">
        <h2 class="text-charcoal-grey">OrsusChain</h2>
      </div>

    </div>
  </div>
</template>

<script>
import Anime from 'animejs';

let distance = 5;
const animeDuration = 800;
const animeEasing = 'easeOutQuint';

export default {
  data() {
    return {
      shown: false,
      show: false,
    }
  },
  mounted() {
    document.addEventListener('aos:in:orsus-chain', ({ detail }) => {
      setTimeout(() => {
        Anime({
          targets: this.$refs.top,
          translateY: -230 - distance,
          duration: animeDuration,
          easing: animeEasing
        })
        Anime({
          targets: this.$refs.left,
          translateX: -240 - distance,
          translateY: -70 - distance,
          duration: animeDuration,
          easing: animeEasing
        })
        Anime({
          targets: this.$refs.right,
          translateX: 240 + distance,
          translateY: -70 - distance,
          duration: animeDuration,
          easing: animeEasing
        })
        Anime({
          targets: this.$refs.bottomRight,
          translateX: 160 + distance,
          translateY: 235 + distance,
          duration: animeDuration,
          easing: animeEasing
        })
        Anime({
          targets: this.$refs.bottomLeft,
          translateX: -160 - distance,
          translateY: 235 + distance,
          duration: animeDuration,
          easing: animeEasing
        })
      }, 300)

      setTimeout(() => {
        this.shown = true;
      }, animeDuration - 300);

      setTimeout(() => {
        this.show = true;
      }, 1000)
    });
  }
};
</script>
